import React from 'react';
import type { IResponse } from '../../../models/IResponse';
import { type IAutocompleteOption } from '../../../models/IAutocompleteOption';
import CButton from '../../../components/CButton';
import CCalculator2dPlot from './CCalculator2dPlot';
import CPageModule from '../../../components/CPageModule';
import { type I2DPlotConfig, type I2DPlotState } from '../../../models/ICalculatorPlot';
import { Add } from '@mui/icons-material';
import CLocalizedTextString from '../../../components/CLocalizedTextString';
import type { IOptionsCalculatorConfig } from '../../../models/IOptionsCalculatorConfig';

interface Props {
  plots: I2DPlotState[];
  optionsTableDerivatives: IResponse<{ options: Array<{ label: string, value: string }> }>;
  optionsConfigDefault: IOptionsCalculatorConfig;
  parameterOptions: IAutocompleteOption[];
  maxPlots: number;
  addPlot: () => void;
  deletePlot: (plotId: string) => void;
  updatePlotConfig: (plotId: string, configUpdate: Partial<I2DPlotConfig>) => void;
}

export default function CCalculator2dPlotManager(props: Props) {

  const dictTitle = CLocalizedTextString('topics.calculator.twoDimPlot.desc');
  const dictPrefix = CLocalizedTextString('topics.calculator.twoDimPlot.plotNumber.prefix');
  const dictSuffix = CLocalizedTextString('topics.calculator.twoDimPlot.plotNumber.suffix');
  const textPrefix = `${dictTitle} ${props.plots.length > 1 ? dictPrefix : ''}`;
  const textSuffix = `${props.plots.length > 1 ? dictSuffix : ''}`;

  return (<>
    <CPageModule fullWidth submodule>
      <CPageModule fullWidth submodule apiRequestState={props.optionsTableDerivatives.state}
                   showContent={!!props.optionsTableDerivatives.data}>
        {props.plots.map((plot, index) => (<CCalculator2dPlot
          key={plot.config.id}
          optionsTableDerivatives={props.optionsTableDerivatives}
          plot2d={plot.data}
          parameterOptions={props.parameterOptions}
          plotConfig={plot.config}
          showDeleteButton={props.plots.length > 1}
          onUpdatePlotConfig={(configUpdate) => {
            props.updatePlotConfig(plot.config.id, configUpdate);
          }}
          onDeletePlot={() => {
            props.deletePlot(plot.config.id);
          }}
          plotIndex={index}
          textPrefix={textPrefix}
          textSuffix={textSuffix}
          optionsConfigDefault={props.optionsConfigDefault}
        />))}
        <CPageModule submodule>
          <CButton onClick={props.addPlot} submodule disabled={props.plots.length >= props.maxPlots} icons={{ start: <Add /> }} style={{borderWidth: 1}} isForm>
            {CLocalizedTextString('topics.calculator.twoDimPlot.addButton')}
          </CButton>
        </CPageModule>
      </CPageModule>
    </CPageModule>
  </>);
}
